<template>
    <div>
        <div class="x-stat">
            <a-row>
                <a-col :span="3">
                    <a-statistic title="数量" :value="totalRow" />
                </a-col>
            </a-row>
        </div>

        <a-card :bordered="false">
            <div class="x-filter">
                <a-form layout="inline">
                    <a-row :gutter="24">
                        <a-col :span="4">
                            <a-form-item label="用户">
                                <a-input v-model="queryParams.user" placeholder="ID/昵称" />
                            </a-form-item>
                        </a-col>
                        <a-col :span="4">
                            <a-form-item label="类型">
                                <a-select v-model="queryParams.actType" placeholder="请选择" default-value="">
                                    <a-select-option value="1">用户资料</a-select-option>
                                    <a-select-option value="2">声音秀</a-select-option>
                                    <a-select-option value="3">相册</a-select-option>
                                    <a-select-option value="4">动态</a-select-option>
                                    <a-select-option value="5">动态评论</a-select-option>
                                    <a-select-option value="6">聊天消息</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <template v-if="advanced">
                            <a-col :md="8">
                                <a-form-item label="创建时间">
                                    <a-range-picker @change="onCreateTime" v-model="createTime" style="width:100%" />
                                </a-form-item>
                            </a-col>
                        </template>
                        <a-col :span="!advanced && 4 || 24">
							<span class="x-filter-submit-box"
                                  :style="advanced && {float:'right', overflow:'hidden'} || {}">
								<a-button type="primary" @click="fetchTableData">查询</a-button>
								<a-button style="margin-left:8px" @click="() => this.queryParams={}">重置</a-button>
								<a @click="toggleAdvanced" style="margin-left: 8px">
									{{ advanced ? '收起' : '展开' }}
									<a-icon :type="advanced ? 'up' : 'down'" />
								</a>
							</span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>

            <a-table :rowKey="record => record.id" :columns="tableColumns" :loading="tableLoading"
                     :dataSource="tableData" :pagination="false">
				<span slot="network" slot-scope="record">
					{{ record.userIp }}:{{ record.userPort }}
				</span>

                <span slot="actType" slot-scope="record">
                    <label v-if="record.actType == 1">用户资料</label>
                    <label v-else-if="record.actType == 2">声音秀</label>
                    <label v-else-if="record.actType == 3">相册</label>
                    <label v-else-if="record.actType == 4">动态</label>
                    <label v-else-if="record.actType == 5">动态评论</label>
                    <label v-else-if="record.actType == 6">聊天消息</label>
                    <label v-else>-</label>
				</span>

                <template slot="actData" slot-scope="record">
                    <div class="content">
                        {{ record.actData }}
                    </div>
                </template>
            </a-table>

            <div class="x-pagination">
                <a-pagination :pageSize="pageSize" v-model="pageIndex" :total="totalRow" @change="pageChange"
                              :hideOnSinglePage="true" show-less-items />
            </div>
        </a-card>
    </div>
</template>

<script>
import moment from "moment";
import { actionLogList } from "@/api/op/actionLog";

const tableColumns = [
    {
        title: '#',
        dataIndex: 'id'
    },
    {
        title: '用户ID',
        dataIndex: 'userId'
    },
    {
        title: 'IP&端口',
        scopedSlots: {
            customRender: 'network'
        }
    },
    {
        title: '类型',
        scopedSlots: {
            customRender: 'actType'
        }
    },
    {
        title: '内容',
        scopedSlots: {
            customRender: 'actData'
        },
        width: 600
    },
    {
        title: '创建时间',
        dataIndex: 'created'
    }
];

export default {
    data() {
        return {
            advanced: false,
            queryParams: {},
            tableLoading: false,
            tableColumns,
            tableData: [],
            totalRow: 0,
            pageSize: 20,
            pageIndex: 1,
            createTime: [],
        }
    },
    created() {
        this.fetchTableData();
    },
    methods: {
        fetchTableData() {
            this.tableLoading = true;
            this.queryParams.pageSize = this.pageSize;
            this.queryParams.page = this.pageIndex;

            actionLogList(this.queryParams).then(res => {
                this.totalRow = res.data.totalRow;
                this.tableData = res.data.recordList;

                this.tableLoading = false;
            });
        },
        toggleAdvanced() {
            this.advanced = !this.advanced;
        },
        onCreateTime(values) {
            this.queryParams.startCreateTime = moment(values[0]).unix();
            this.queryParams.endCreateTime = moment(values[1]).unix();
        },
        pageChange(current) {
            this.pageIndex = current;
            this.fetchTableData();
        },
    }
}
</script>

<style scoped>
.content {
    word-break: break-all;
    white-space: normal;
}
</style>